// const lazyImageObserverCallback = (entries, observer) => {
//   entries.forEach((entry) => {
//     if (entry.isIntersecting) {
//       const img = entry.target;
//       img.src = img.dataset.src;
//       img.srcset = img.dataset.srcset;
//       img.classList.add("loading__image");

//       img.onload = () => {
//         img.classList.add("loaded");
//         img.classList.remove("loading__image");

//         observer.unobserve(img);

//         // Check if all images in the wrapper are loaded
//         const wrapper = img.closest(".lazy-image-wrapper");
//         const allImages = wrapper.querySelectorAll("img.lazy-load");
//         const allLoaded = Array.from(allImages).every((i) => i.classList.contains("loaded"));

//         // if (allLoaded) {
//         //   const cardMedia = img.closest(".card__media");
//         //   if (cardMedia) {
//         //     cardMedia.classList.add("all_imgs_loaded");
//         //   }
//         // }
//       };
//     }
//   });
// };

// function lazyLoadImages(selector = "img.lazyload") {
//   const lazyImages = document.querySelectorAll(selector);

//   if ("IntersectionObserver" in window) {
//     const lazyImageObserver = new IntersectionObserver(lazyImageObserverCallback);

//     lazyImages.forEach((img) => {
//       img.loading = "lazy";
//       lazyImageObserver.observe(img);
//     });
//   } else {
//     // Fallback for unsupported browsers
//     lazyImages.forEach((img) => {
//       img.src = img.dataset.src;
//       img.srcset = img.dataset.srcset;

//       img.onload = () => {
//         img.classList.add("loaded");
//         img.classList.remove("loading__image");

//         const wrapper = img.closest(".lazy-image-wrapper");
//         const allImages = wrapper.querySelectorAll("img.lazy-load");
//         const allLoaded = Array.from(allImages).every((i) => i.classList.contains("loaded"));

//         // if (allLoaded) {
//         //   const cardMedia = img.closest(".card__media");
//         //   if (cardMedia) {
//         //     cardMedia.classList.add("all_imgs_loaded");
//         //   }
//         // }
//       };
//     });
//   }
// }

// document.addEventListener("click", function () {
//   lazyLoadImages();
// });

lazyLoadImages();
// function checkMediaLoadedForCard(card) {
//   const mediaElements = card.querySelectorAll('img, video');
//   let loadedCount = 0;

//   if (mediaElements.length === 0) {
//     card.classList.add('all-media-loaded');
//     return;
//   }

//   const checkAndAddClass = () => {
//     loadedCount++;
//     if (loadedCount === mediaElements.length) {
//       card.classList.add('all-media-loaded');
//     }
//   };

//   mediaElements.forEach(media => {
//     const isImageLoaded = media.tagName === 'IMG' && media.complete && media.naturalHeight !== 0;
//     const isVideoLoaded = media.tagName === 'VIDEO' && media.readyState >= 3;

//     if (isImageLoaded || isVideoLoaded) {
//       checkAndAddClass();
//     } else {
//       const onLoad = () => {
//         checkAndAddClass();
//         media.removeEventListener('load', onLoad);
//         media.removeEventListener('loadeddata', onLoad);
//       };

//       media.addEventListener('load', onLoad);         // for images
//       media.addEventListener('loadeddata', onLoad);   // for videos
//     }
//   });
// }

// function checkAllMediaLoaded() {
//   const mediaCards = document.querySelectorAll('.card__media');
//   mediaCards.forEach(card => checkMediaLoadedForCard(card));
// }

// function observeNewCardMedia() {
//   const observer = new MutationObserver(mutations => {
//     mutations.forEach(mutation => {
//       mutation.addedNodes.forEach(node => {
//         if (node.nodeType === 1) {
//           if (node.classList.contains('card__media')) {
//             checkMediaLoadedForCard(node);
//           } else {
//             const nestedCards = node.querySelectorAll?.('.card__media');
//             nestedCards?.forEach(card => checkMediaLoadedForCard(card));
//           }
//         }
//       });
//     });
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// }

// document.addEventListener('DOMContentLoaded', () => {
//   checkAllMediaLoaded();
//   observeNewCardMedia();
// });